<template>
  <div class="section warehousing-detail">
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      label-position="left"
      :show-message="false"
      :disabled="isLook"
    >
      <el-collapse :value="collapse">
        <el-collapse-item
          title="仓库信息"
          :name="1"
        >
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="进仓编号"
                required
                prop="warehouseNo"
              >
                <el-input v-model="form.warehouseNo" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="通知单位"
                prop="notifyCmpId"
              >
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Company"
                  filterable
                  :default-value="form.notifyCmpId||''"
                  tag-name="chineseName"
                  style="width:100%;"
                  :method-params="{customer:true,tradersSign:true,factorySign:true, collectionType:'or'}"
                  @parentCallBack="p=>form.notifyCmpId=p.value"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="最早进仓时间"
                prop="warehouseInDateFrom"
              >
                <el-date-picker
                  v-model="form.warehouseInDateFrom"
                  type="date"
                  clearable
                  style="width:100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="最晚进仓时间"
                prop="warehouseInDateTo"
              >
                <el-date-picker
                  v-model="form.warehouseInDateTo"
                  type="date"
                  clearable
                  style="width:100%;"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="仓库供应商"
                prop="supplierId"
              >
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Company"
                  filterable
                  :default-value="form.supplierId||''"
                  tag-name="chineseName"
                  style="width:100%;"
                  :method-params="{warehouse:true}"
                  @parentCallBack="supplierChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="仓库名称"
                prop="warehouseUuid"
              >
                <cargo-advance-select
                  :cache="false"
                  filterable
                  :remote="true"
                  :url="URL.warehouseIn.queryWarehouseInfo"
                  :default-value="form.warehouseUuid"
                  :method-params="{supplierId:form.supplierId||''}"
                  :remote-default-obj="{warehouse:form.warehouse,uuid:form.warehouseUuid}"
                  tag-name="warehouse"
                  tag-value="uuid"
                  style="width:100%;"
                  @parentCallBack="warehouse=>warehouseCallback(warehouse)"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="预计离港时间"
                prop="etd"
              >
                <el-date-picker
                  v-model="form.etd"
                  type="date"
                  clearable
                  style="width:100%;"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="仓库联系人"
                prop="warehouseContact"
              >
                <el-input v-model="form.warehouseContact" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="联系电话"
                prop="warehouseContactTel"
              >
                <el-input v-model="form.warehouseContactTel" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item
                label="仓库地址"
                prop="warehouseAddress"
              >
                <el-input
                  v-model="form.warehouseAddress"
                  type="textarea"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item
                label="进仓要求"
                prop="warehouseInRequirement"
              >
                <el-input
                  v-model="form.warehouseInRequirement"
                  type="textarea"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item
          title="进仓信息"
          :name="2"
        >
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="回执单号"
                prop="receiptNo"
              >
                <el-input v-model="form.receiptNo" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="进仓状态"
                prop="state"
                disabled
              >
                <el-select
                  v-model="form.state"
                  disabled
                >
                  <el-option
                    label="未进仓"
                    :value="0"
                  />
                  <el-option
                    label="部分进仓"
                    :value="1"
                  />
                  <el-option
                    label="已全部进仓"
                    :value="2"
                  />
                  <el-option
                    label="进仓异常"
                    :value="-1"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item
                label="送货公司"
                prop="deliveryCmp"
              >
                <el-input v-model="form.deliveryCmp" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="车牌号"
                prop="truckNo"
              >
                <el-input v-model="form.truckNo" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="车辆类型"
                prop="vehicleType"
              >
                <cargo-advance-select
                  :cache="false"
                  filterable
                  :url="URL.warehouseIn.queryVehicleType"
                  :default-value="form.vehicleType"
                  tag-name="name"
                  tag-value="code"
                  style="width:100%;"
                  @parentCallBack="p=>form.vehicleType=p.value"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="司机"
                prop="driver"
              >
                <el-input v-model="form.driver" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="司机电话"
                prop="driverTel"
              >
                <el-input v-model="form.driverTel" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item
                label="备注"
                prop="remarks"
              >
                <el-input
                  v-model="form.remarks"
                  type="textarea"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item
          title="货物明细"
          :name="3"
        >
          <cargo-detail
            ref="packageInfo"
            :operation-type="oprationType"
            :warehouse-in-uuid="warehouseInUuid"
            :refresh-base-info="handleGetWarehouseInInfo"
          />
        </el-collapse-item>
        <el-collapse-item
          title="进仓照片"
          :name="4"
        >
          <pic-list
            :operation-type="oprationType"
            :warehouse-in-uuid="warehouseInUuid"
          />
        </el-collapse-item>
      </el-collapse>
    </el-form>
  </div>
</template>
<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import { queryWarehouseIn } from '@/api/OMS/warehouseIn'
import cargoDetail from './cargoDetail'
import picList from './picList'
import { getLoading } from '@/utils/utilBaseElement'
export default {
  name: 'BaseInfo',
  components: {
    cargoAdvanceSelect,
    cargoDetail,
    picList
  },
  props: {
    warehouseInUuid: { type: String, default: () => '' },
    oprationType: { type: Number, default: () => 1 }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      URL,
      form: {
        uuid: '',
        warehouseNo: '',
        warehouseInDateFrom: '',
        warehouseInDateTo: '',
        supplierId: '',
        warehouse: '',
        warehouseUuid: '',
        warehouseAddress: '',
        warehouseContact: '',
        warehouseContactTel: '',
        warehouseInRequirement: '',
        etd: '',
        receiptNo: '',
        deliveryCmp: '',
        truckNo: '',
        vehicleType: '',
        driver: '',
        driverTel: '',
        remarks: '',
        state: 0,
        notifyCmpId: 0,
        version: null
      },
      collapse: [0, 1, 2, 3, 4, 5],
      warehouseInInfo: null
    }
  },
  computed: {
    isLook() {
      return this.oprationType !== 2 && this.oprationType !== 3
    }
  },
  watch: {
    warehouseInUuid(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.handleGetWarehouseInInfo()
      } else {
        this.$refs.form.resetFields()
        this.warehouseInInfo = null
      }
    },
    oprationType(val) {
      if (val !== 2) {
        this.handleGetWarehouseInInfo()
      } else {
        this.form.version = null
      }
    }
  },
  methods: {
    handleGetWarehouseInInfo() {
      this.loading = getLoading()
      const { warehouseInUuid } = this
      queryWarehouseIn({ warehouseInUuid: warehouseInUuid })
        .then((res) => {
          this.warehouseInInfo = res.data
          Object.keys(this.form).forEach((key) => {
            if (res.data[key]) {
              this.form[key] = res.data[key]
              if (key === 'warehouseInUuid') {
                this.form[key] = res.data['uuid']
              }
            }
          })
          this.loading.close()
        })
        .catch(() => {
          this.loading.close()
        })
    },
    warehouseCallback(warehouse) {
      console.log('change', warehouse)
      this.form.warehouseUuid = warehouse.uuid
      this.form.uuid = warehouse.uuid
      this.form.warehouse = warehouse.warehouse
      this.form.warehouseAddress = warehouse.warehouseAddress
      this.form.warehouseContact = warehouse.warehouseContact
      this.form.warehouseContactTel = warehouse.warehouseContactTel
    },
    supplierChange(params) {
      this.form.supplierId = params.value
      this.form.warehouseUuid = ''
      this.form.uuid = ''
      this.form.warehouse = ''
      this.form.warehouseAddress = ''
      this.form.warehouseContact = ''
      this.form.warehouseContactTel = ''
    }
  }
}
</script>

<style lang="scss">
.warehousing-detail {
  .el-collapse {
    &-item {
      &__header {
        padding: 0 15px;
        border-bottom: none;
        color: #4283ff;
        font-weight: bold;
        background-color: #fff;
      }
      &__wrap {
        padding: 15px;
        border-bottom: none;
        background-color: #f0f3f8!important;
      }
      &__arrow {
        color: #303133;
      }
    }
  }
}
</style>
